<template>
  <main-content>
    <div v-if="status == 'success'" class="bg-white shadow-sm p-3 my-2" style="border-radius: 10px">   
      <form @submit.prevent="submitForm" id="submit">
      <div class="d-flex align-items-center px-3">
        <div class="ml-auto">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#00bea5"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
          <span class="pr-2">تسهیم</span>
        </div>
        <div>
          <button
            type="submit"
            class="btn btn-success px-4"
            style="border-radius: 10px"
          >
            بروزرسانی
          </button>
        </div>
      </div>
      <hr />
        <div id="message-div"></div>
        <div class="form-group form-check py-2">
          <label class="switch">
            <input
              type="checkbox"
              id="allotment_status"
              name="collective_status"
              v-model="form_data.status"
            />
            <span class="slider round"></span>
          </label>
          <label
            for="allotment_status"
            class="btn m-0 p-0 text-secondary form-check-label pr-4"
            >وضعیت تسهیم</label
          >
        </div>

        <div v-if="form_data.status == 1">
          <div>
            <div>
              <div>
                <label>
                  <div class="h5">
                    {{ $t("allotment.allotment_details") }}
                  </div>
                </label>
              </div>
              <div class="pl-3">
                <div class="form-group form-check py-2">
                  <label class="switch">
                    <input
                      type="checkbox"
                      id="transaction_allotment"
                      name="transaction_allotment"
                      v-model="form_data.transaction_allotment"
                    />
                    <span class="slider round"></span>
                  </label>
                  <label
                    for="transaction_allotment"
                    class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >استفاده از لیست تسهیم تراکنش</label
                  >
                </div>

                <div>
                  <form id="allotment_user" @submit.prevent="fetchShebas">
                    <div class="d-flex justify-content-center align-items-top">
                      <div class="mx-4">
                        <input
                          class="user_id form-control"
                          name="user_id"
                          id="user_id"
                          :placeholder="$t('allotment.user_id')"
                        />
                      </div>
                      <div class="mx-4">
                          <div class="mt-1">
                            <button
                            class="btn btn-success"
                            type="submit"
                            id="fetch_user_shebas_btn"
                            >
                            {{ $t("btn.fetchShebas") }}
                            </button>
                          </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="px-3 my-3">
                <table
                  class="table table-striped"
                  v-if="allotment_users.length > 0"
                >
                  <thead>
                    <tr style="font-size: 0.89rem">
                      <td style="text-align: center; width: 15%">#</td>
                      <td style="text-align: center; width: 20%">
                        {{ $t("allotment.user_full_name") }}
                      </td>
                      <td style="text-align: center; width: 40%">
                        {{ $t("allotment.user_shebas") }}
                      </td>
                      <td style="text-align: center; width: 20%">
                        {{ $t("allotment.percent") }}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-bind:key="index"
                      v-for="(user, index) in allotment_users"
                      class="table-row"
                    >
                      <td style="text-align: center; width: 15%">
                        <input
                          style="text-align: center"
                          type="text"
                          name="user-id"
                          id="user-id"
                          class="form-control"
                          v-model="user.user_id"
                          disabled
                        />
                      </td>
                      <td style="text-align: center; width: 25%">
                        <input
                          type="text"
                          class="form-control"
                          style="text-align: center"
                          :value="user.user_full_name"
                          disabled
                        />
                      </td>
                      <td style="text-align: center; width: 35%">
                        <select class="form-control kt-selectpicker" v-model="user.sheba_id" id="sheba_list">
                          <option
                            v-bind:key="sheba_number.id"
                            class="en_num"
                            v-for="sheba_number in user.sheba_numbers"
                            :value="sheba_number.id"
                            :selected="user.sheba_id === sheba_number.id"
                          >
                            {{ sheba_number.number }}
                          </option>
                        </select>
                      </td>
                      <td style="text-align: center; width: 20%">
                        <input
                          type="number"
                          name="allotment_percent"
                          id="allotment_percent"
                          max="99"
                          min="1"
                          class="form-control allotment_percent"
                          v-model="user.percent"
                          :placeholder="$t('allotment.allotment_percent')"
                        />
                      </td>
                      <td style="text-align: center; width: 5%">
                        <button
                          id="reset_from_date"
                          @click="deleteUser(index)"
                          class="btn"
                          type="button"
                        >
                          <span>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#ea3324"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
                          </span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </main-content>
</template>

<script>
import mainContent from "@/components/main-content";
import { i18n } from "@/plugins/i18n";
import $ from "jquery";
import { allotmentService } from "@/common/api.service";
import { mapGetters } from "vuex";

export default {
  name: "allotment",
  components: {
    "main-content": mainContent,
  },
  data() {
    return {
      user_id: null,
      allotment_users: [],
    };
  },
  computed: {
    ...mapGetters("allotment", {
      form_data: "form_data",
      status: "status",
      user_shebas: "user_shebas",
      fetch_user_status: "fetch_user_status",
    }),
  },
  mounted() {
    this.loadAllotments();
    this.initial();
  },
  methods: {
    deleteUser(index) {
      this.allotment_users.pop(index);
    },
    loadAllotments() {
      allotmentService.find(this.$route.params.hashid).then((response) => {
        this.allotment_users = response.data.data.allotments;
        this.$store.dispatch("allotment/find", response.data.data).then(()=>{
            setTimeout(() => {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 1000);
        });
      });
    },
    initial() {
      $("#allotment_repeater_list").repeater({
        initEmpty: false,
        isFirstItemUndeletable: true,
        show: function () {
          $(this).slideDown();
        },
        defaultValues: {
          "text-input": null,
        },
        hide: function (deleteElement) {
          $(this).slideUp(deleteElement);
        },
      });

      let c = 0;
      let interval = setInterval(
        function () {
          if (c > 3) clearInterval(interval);
          c++;
        }.bind(this),
        1000
      );
    },
    submitForm() {
      let form = $("#message-div");
      let btn = $("#submit_btn");

      allotmentService
        .sync(this.$route.params.hashid, {
          allotments: this.allotment_users,
          status: this.form_data.status,
          transaction_allotment: this.form_data.transaction_allotment,
        })
        .then((response) => {
          this.showMsg(form, "success", response.data.message);
        })
        .catch(({ response }) => {
          this.showMsg(form, "danger", response.data.message);
        })
        .finally(() => {});
    },
    fetchShebas(e) {
      let form = $(e.target);
      let btn = $("#fetch_user_shebas_btn");

      form.validate({
        rules: {
          user_id: {
            required: true,
            minlength: 5,
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      this.user_id = $("#user_id").val();
      let params = {
        hashid: this.user_id,
      };

      allotmentService
        .fetchUserShebas(params)
        .then((response) => {
          let new_row = response.data.data;
          this.allotment_users.push(new_row);
          this.$store.dispatch("allotment/fetchUserShebas", new_row).then(() => {
              setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 1000);
          });
          $("#user_id").val('');
        })
        .catch(({ response }) => {
          let form = $("#submit");
          this.showMsg(form, "danger", response.data.message);
        });
    },
  },
};
</script>

<style>
.is-disabled {
  pointer-events: none;
  opacity: 0.4;
  /*display: none;*/
}
.no-border {
  border: none !important;
}
</style>